var triggerCancellable = function (trigger, event) {
  var doTrigger = function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return new Promise(function (resolve, reject) {
      var results = trigger.apply(void 0, [event].concat(args));

      if (results && results.length) {
        Promise.all(results)["catch"](reject).then(function (resolvedResults) {
          return resolvedResults && resolve(!!~resolvedResults.findIndex(function (r) {
            return r === false;
          }));
        });
      } else {
        resolve(false);
      }
    });
  };

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return event ? doTrigger.apply(void 0, [event].concat(args)) : doTrigger;
};

export default triggerCancellable;